import { PaacsbankdetailsModule } from './../pages/paacs/paacsbankdetails/paacsbankdetails.module';
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guard/auth.guard";
import { ManufacturerDetailComponent } from "src/app/views/pages/dbt/manufacturer-detail/manufacturer-detail.component";
import { DealerManufactureViewComponent } from "../pages/dbt/dealermanufacture/dealermanufactureview.component";
import { UserfbDetailsComponent } from "../pages/master/userfeedbackhistory/userfb-detail/userfb-detail.component";
import { BaseComponent } from "./base/base.component";
import { AeefarmerbookingapprovalviewComponent } from '../pages/aeefarmerbookingapproval/aeefarmerbookingapprovalview/aeefarmerbookingapprovalview.component';
import { EefarmerbookingapprovalviewComponent } from '../pages/aeefarmerbookingapproval/eefarmerbookingapprovalview/eefarmerbookingapprovalview.component';
import { EefarmerbookingapprovalComponent } from '../pages/aeefarmerbookingapproval/eefarmerbookingapproval/eefarmerbookingapproval.component';
import { ToggleMachImpleComponent } from '../pages/Private EVaadagai/serviceprovider/toggle-mach-imple/toggle-mach-imple.component';
import { TicketingSystemComponent } from '../pages/ticketing-system/ticketing-system.component';
import { RunLotteryComponent } from '../pages/master/run-lottery/run-lottery.component';
import { LotteryDashboardComponent } from '../pages/master/lottery-dashboard/lottery-dashboard.component';
import { LotteryReportComponent } from '../pages/master/lottery-report/lottery-report.component';
import { ManufacturerReportComponent } from '../pages/master/manufacturerreport/manufacturerreport.component';
import { DbtDistrictWiseFlowProgressReportComponent } from '../pages/master/dbtdistrictwiseflowprogressreport/dbtdistrictwiseflowprogressreport.component';
import { DbtDivisionWiseFlowProgressReportComponent } from '../pages/master/dbtdivisionwiseflowprogressreport/dbtdivisionwiseflowprogressreport.component';
import { DbtVillageWiseFlowProgressReportComponent } from '../pages/master/dbtvillagewiseflowprogressreport/dbtvillagewiseflowprogressreport.component';
// import { FarmertimelineComponent } from "../pages/dbt/farmertimeline/farmertimeline.component";


const routes: Routes = [
  {
    path: '',
    component: BaseComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'home',
        // loadChildren: () => import('./views/pages/dashboard/dashboard.module').then(m => m.DashboardModule)
        loadChildren: () => import('./../../views/pages/realtimetracking/realtimetracking.module').then(m => m.RealTimeTrackingModule)

      },
      {
        path: 'dashboard',
        // loadChildren: () => import('./views/pages/dashboard/dashboard.module').then(m => m.DashboardModule)
        loadChildren: () => import('./../../views/pages/realtimetracking/realtimetracking.module').then(m => m.RealTimeTrackingModule)
      },
      // {
      //   path: 'dashboard/:id',
      //   loadChildren: () => import('./views/pages/dashboard/dashboard.module').then(m => m.DashboardModule)
      // },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },

      {
        path: 'realtimetracking',
        loadChildren: () => import('./../../views/pages/realtimetracking/realtimetracking.module').then(m => m.RealTimeTrackingModule)
      },
      {
        path: 'smamdashboard',
        loadChildren: () => import('./../../views/pages/smamdashboard/smamdashboard.module').then(m => m.SmamdashboardModule)
      },
      {
        path: 'users',
        loadChildren: () => import('./../../views/pages/master/user/user.module').then(m => m.UserModule)
      },
      {
        path: 'devices',
        loadChildren: () => import('./../../views/pages/master/device/device.module').then(m => m.DeviceModule)
      },
      {
        path: 'providers',
        loadChildren: () => import('./../../views/pages/master/provider/provider.module').then(m => m.ProviderModule)
      },
      {
        path: 'drivers',
        loadChildren: () => import('./../../views/pages/master/driver/driver.module').then(m => m.DriverModule)
      },
      {
        path: 'serviceschedules',
        loadChildren: () => import('./../../views/pages/master/serviceschedule/serviceschedule.module').then(m => m.ServicescheduleModule)
      },
      {
        path: 'livetrack',
        loadChildren: () => import('./../../views/pages/tracking/livetrack/livetrack.module').then(m => m.LivetrackModule)
      },
      {
        path: 'livetrack/:id',
        loadChildren: () => import('./../../views/pages/tracking/livetrack/livetrack.module').then(m => m.LivetrackModule)
      },
      {
        path: 'realtimecharts',
        loadChildren: () => import('./../../views/pages/realtimetracking_charts/realtimetracking_charts.module').then(m => m.RealtimetrackingChartsModule)
      },
      {
        path: 'evaadagaidashboard',
        loadChildren: () => import('./../../views/pages/mhire/mhiredashboard/mhiredashboard.module').then(m => m.MhiredashboardChartsModule)
      },
      {
        path: 'realtimecharts/:id',
        loadChildren: () => import('./../../views/pages/realtimetracking_charts/realtimetracking_charts.module').then(m => m.RealtimetrackingChartsModule)
      },
      {
        path: 'vehiclegroups',
        loadChildren: () => import('./../../views/pages/master/vehiclegroup/vehiclegroup.module').then(m => m.VehiclegroupModule)
      },
      {
        path: 'vehicles',
        loadChildren: () => import('./../../views/pages/master/vehicle/vehicle.module').then(m => m.VehicleModule)
      },
      {
        path: 'devicesswap',
        loadChildren: () => import('./../../views/pages/master/devicesswap/devicesswap.module').then(m => m.DevicesswapModule)
      },
      {
        path: 'fuellog',
        loadChildren: () => import('./../../views/pages/rollcall/fuellog/fuellog.module').then(m => m.FuelLogModule)
      },
      {
        path: 'farmerentries',
        loadChildren: () => import('./../../views/pages/rollcall/farmer/farmer.module').then(m => m.FarmerModule)
      },
      {
        path: 'servicelog',
        loadChildren: () => import('./../../views/pages/rollcall/servicelog/servicelog.module').then(m => m.ServiceLogModule)
      },
      {
        path: 'triplog',
        loadChildren: () => import('./../../views/pages/rollcall/triplog/triplog.module').then(m => m.TripLogModule)
      },
      {
        path: 'profile/:actionInfo',
        loadChildren: () => import('./../../views/pages/profile/profile/profile.module').then(m => m.ProfileModule)
      },
      {
        path: 'tripreport',
        loadChildren: () => import('./../../views/pages/reports/tripreport/tripreport.module').then(m => m.TripReportModule)
      },
      {
        path: 'dailyreport',
        loadChildren: () => import('./../../views/pages/reports/dailyreport/dailyreport.module').then(m => m.DailyReportModule)
      },
      {
        path: 'weeklyreport',
        loadChildren: () => import('./../../views/pages/reports/weeklyreport/weeklyreport.module').then(m => m.WeeklyReportModule)
      },
      {
        path: 'monthlyreport',
        loadChildren: () => import('./../../views/pages/reports/monthlyreport/monthlyreport.module').then(m => m.MonthlyReportModule)
      },
      {
        path: 'outturnreport',
        loadChildren: () => import('./../../views/pages/reports/outturnreport/outturnreport.module').then(m => m.OutturnReportModule)
      },
      {
        path: 'stoppagetruckreport',
        // tslint:disable-next-line: max-line-length
        loadChildren: () => import('./../../views/pages/reports/stoppagetruckreport/stoppagetruckreport.module').then(m => m.StoppagetruckreportModule)
      },
      {
        path: 'tripsimulationreport',
        // tslint:disable-next-line: max-line-length
        loadChildren: () => import('./../../views/pages/reports/tripsimulationreport/tripsimulationreport.module').then(m => m.TripsimulationModule)
      },
      {
        path: 'devicelog',
        // tslint:disable-next-line: max-line-length
        loadChildren: () => import('./../../views/pages/reports/devicelog/devicelog.module').then(m => m.DevicelogModule)
      },
      {
        path: 'regions',
        loadChildren: () => import('./../../views/pages/master/region/region.module').then(m => m.RegionModule)
      },
      {
        path: 'divisions',
        loadChildren: () => import('./../../views/pages/master/division/division.module').then(m => m.DivisionModule)
      },
      {
        path: 'subdivisions',
        loadChildren: () => import('./../../views/pages/master/subdivision/subdivision.module').then(m => m.SubDivisionModule)
      },
      {
        path: 'workshops',
        loadChildren: () => import('./../../views/pages/master/workshop/workshop.module').then(m => m.WorkshopModule)
      },

      {
        path: 'implements',
        loadChildren: () => import('./../../views/pages/master/implements/implement.module').then(m => m.ImplementModule)
      },
      {
        path: 'tariffs',
        loadChildren: () => import('./../../views/pages/master/tarrif/tarrif.module').then(m => m.TarrifModule)
      },
      {
        path: 'tripentries',
        loadChildren: () => import('./../../views/pages/rollcall/tripentry/tripentry.module').then(m => m.TripEntryModule)
      },
      {
        path: 'targets',
        loadChildren: () => import('./../../views/pages/master/target/target.module').then(m => m.TargetModule)
      },

      {
        path: 'targetset',
        loadChildren: () => import('./../../views/pages/master/targetset/targetset.module').then(m => m.TargetsetModule)
      },
      {
        path: 'targetset/:id',
        loadChildren: () => import('./../../views/pages/master/targetassign/targetassign.module').then(m => m.TargetassignModule)
      },
      {
        path: 'expenselogs',
        loadChildren: () => import('./../../views/pages/master/expense/expense.module').then(m => m.ExpenseModule)
      },
      {
        path: 'consumables',
        loadChildren: () => import('./../../views/pages/master/consumable/consumable.module').then(m => m.ConsumableModule)
      },
      {
        path: 'cashbooking',
        loadChildren: () => import('./../../views/pages/mhire/cashbooking/cashbookingentry.module').then(m => m.CashbookingModule)
      }
      ,
      {
        path: 'consumableentries',
        loadChildren: () => import('./../../views/pages/rollcall/consumableentry/consumableentry.module').then(m => m.ConsumableentryModule)
      },
      {
        path: 'expenseentries',
        loadChildren: () => import('./../../views/pages/rollcall/expenseentry/expenseentry.module').then(m => m.ExpenseentryModule)
      },
      {
        path: 'makes',
        loadChildren: () => import('./../../views/pages/master/make/make.module').then(m => m.MakeModule)
      },
      {
        path: 'models',
        loadChildren: () => import('./../../views/pages/master/model/model.module').then(m => m.ModelModule)
      },
      {
        path: 'homeconnect',
        loadChildren: () => import('./../../views/pages/master/homeconnect/homeconnect.module').then(m => m.HomeconnectModule)
      },
      {
        path: 'quickrollcallentry',
        loadChildren: () => import('./../../views/pages/rollcall/quickentry/quickentry.module').then(m => m.QuickentryModule)
      },
      {
        path: 'quickrollcallentry/:id',
        loadChildren: () => import('./../../views/pages/rollcall/quickentry/quickentry.module').then(m => m.QuickentryModule)
      },
      {
        path: 'machineryallocate',
        loadChildren: () => import('./../../views/pages/mhire/machineryallocate/machineryallocate.module').then(m => m.MachineryallocateModule)
      },
      {
        path: 'oldlogbook',
        loadChildren: () => import('./../../views/pages/mhire/oldlogbook/logbook.module').then(m => m.LogbookModule)
      },
      {
        path: 'mhirelogbook',
        loadChildren: () => import('./../../views/pages/mhire/mhirelogbook/mhirelogbook.module').then(m => m.MhirelogbookModule)
      },
      {
        path: 'blockvillagemaping',
        loadChildren: () => import('./../../views/pages/master/block-village-maping/block-village-maping.module').then(m => m.BlockVillageMapingModule)
      },
      {
        path: 'blockvillagemaping/:id',
        loadChildren: () => import('./../../views/pages/master/block-village-maping/block-village-maping.module').then(m => m.BlockVillageMapingModule)
      },
      {
        path: 'panchayatvillagemapping',
        loadChildren: () => import('./../../views/pages/master/panchayat-village-mapping/panchayt-village-mapping.module').then(m => m.PanchaytVillageMappingModule)
      },
      {
        path: 'panchayatvillagemapping/:id',
        loadChildren: () => import('./../../views/pages/master/panchayat-village-mapping/panchayt-village-mapping.module').then(m => m.PanchaytVillageMappingModule)
      },
      {
        path: 'bookingreport',
        loadChildren: () => import('./../../views/pages/reports/bookingreport/bookingreport.module').then(m => m.BookingReportModule)
      },
      {
        path: 'dbtbookingreport',
        loadChildren: () => import('./../../views/pages/reports/dbtbookingdetailreport/dbtbookingdetailreport.module').then(m => m.DbtbookingdetailreportModule)
      },
      {
        path: 'mechanizationreport',
        loadChildren: () => import('./../../views/pages/reports/mechanization/mechanization.module').then(m => m.MechanizationModule)
      },
      {
        path: 'refundapproval',
        loadChildren: () => import('./../../views/pages/mhire/refundapproval/refundapproval.module').then(m => m.RefundapprovalModule)
      },
      {
        path: 'onlinereceipts',
        loadChildren: () => import('./../../views/pages/mhire_accounts/settlement/settlement.module').then(m => m.SettlementModule)
      },
      {
        path: 'cashreceipts',
        loadChildren: () => import('./../../views/pages/mhire_accounts/poolaccounttransfer/poolaccounttransfer.module').then(m => m.PoolaccounttransferModule)
      },
      {
        path: 'treasurytransfer',
        loadChildren: () => import('./../../views/pages/mhire_accounts/treasurytransfer/treasurytransfer.module').then(m => m.TreasurytransferModule)
      },
      {
        path: 'departmentbooking',
        loadChildren: () => import('./../../views/pages/mhire/departmentbooking/departmentbooking.module').then(m => m.DepartmentbookingModule)
      },
      {
        path: 'mhiredemo',
        loadChildren: () => import('./../../views/pages/mhire/mhiredemo/mhiredemo.module').then(m => m.MhiredemoModule)
      },
      {
        path: 'scheme',
        loadChildren: () => import('./../../views/pages/mhire/scheme/scheme.module').then(m => m.SchemeModule)
      },
      {
        path: 'news',
        loadChildren: () => import('./../../views/pages/mhire/news/news.module').then(m => m.NewsModule)
      },
      {
        path: 'blocks',
        loadChildren: () => import('./../../views/pages/master/block/block.module').then(m => m.BlockModule)
      },
      {
        path: 'vehiclecategory',
        loadChildren: () => import('./../../views/pages/master/vehiclecategory/vehiclecategory.module').then(m => m.VehiclecategoryModule)
      },
      {
        path: 'bookingfailedtrace',
        loadChildren: () => import('../../views/pages/mhire/bookingfailedtrace/bookingfailedtrace.module').then(m => m.BookingFailedTraceModule)
      },
      {
        path: 'terms',
        loadChildren: () => import('./../../views/pages/master/termsandcondition/termsandcondition.module').then(m => m.TermsandconditionModule)
      },
      {
        path: 'Implement',
        loadChildren: () => import('./../../views/pages/master/addimplement/addimplement.module').then(m => m.AddimplementModule)
      },
      {
        path: 'billreport',
        loadChildren: () => import('./../../views/pages/reports/billreport/billreport.module').then(m => m.BillReportModule)
      },
      {
        path: 'machinerystatusreport',
        loadChildren: () => import('./../../views/pages/reports/machinerystatusreport/machinerystatusreport.module').then(m => m.MachinerystatusreportModule)
      },
      {
        path: 'toberemittedintreasuryreport',
        loadChildren: () => import('./../../views/pages/reports/remittedtreasuryreport/remittedtreasuryreport.module').then(m => m.RemittedtreasuryreportModule)

      },
      {
        path: 'treasuryremittedreport',
        loadChildren: () => import('./../../views/pages/reports/treasuryremittedreport/treasuryremittedmodule.module').then(m => m.TreasuryremittedmoduleModule)

      },
      {
        path: 'utilizationreport',
        loadChildren: () => import('./../../views/pages/reports/utilizationreport/utilizationreport.module').then(m => m.UtilizationreportModule)

      },
      {
        path: 'divisionwiseutilizationreport',
        loadChildren: () => import('./../../views/pages/reports/divisionwiseutilizationreport/divisionwiseutilizationreport.module').then(m => m.DivisionWiseUtilizationreportModule)

      },
      {
        path: 'bookingavailability',
        loadChildren: () => import('./../../views/pages/mhire/bookingavailability/bookingavailability.module').then(m => m.BookingavailabilityModule)
      },
      {
        path: 'vehicleorder',
        loadChildren: () => import('./../../views/pages/master/vehicleorder/vehicleorder.module').then(m => m.VehicleOrderModule)
      },
      {
        path: 'machinerywisereport',
        loadChildren: () => import('./../../views/pages/reports/machinery-wise-report/machinery-wise-report.module').then(m => m.MachineryWiseReportModule)
      },
      {
        path: 'waitinglistreport',
        loadChildren: () => import('./../../views/pages/reports/waiting-list-report/waiting-list-report.module').then(m => m.WaitingListReportModule)
      },
      {
        path: 'departmentreceipts',
        loadChildren: () => import('./../../views/pages/mhire_accounts/departmentreciept/departmentreceipt.module').then(m => m.DepartmentReceiptModule)
      },
      {
        path: 'districtwisestatusreport',
        loadChildren: () => import('./../../views/pages/reports/districtwisestatusreport/districtwisestatusreport.module').then(m => m.DistrictWiseStatusReport)
      },
      {
        path: 'districtwisemachineryaddedreport',
        loadChildren: () => import('./../../views/pages/reports/districtwisemachineryaddedreport/districtwisemachineryaddedreport.module').then(m => m.DistrictwisemachineryaddedreportModule)
      },
      {
        path: 'paccsdistrictmachinaryreport',
        loadChildren: () => import('./../../views/pages/reports/districtwisemachineryaddedreport/districtwisemachineryaddedreport.module').then(m => m.DistrictwisemachineryaddedreportModule)
      },

      // {
      //   path: 'reviewreport',
      //   loadChildren: () => import('./../../views/pages/reports/reviewreport/reviewreport.module').then(m => m.ReviewreportModule)
      // },
      {
        path: 'regionwisereviewreport',
        loadChildren: () => import('./../../views/pages/reports/regionwisereviewreport/regionwisereviewreport.module').then(m => m.RegionwisereviewreportModule)
      },
      {
        path: 'schemewisereport',
        loadChildren: () => import('./../../views/pages/reports/schemewisereport/schemewisereport.module').then(m => m.SchemewisereportModule)
      },
      {
        path: 'divisionwisereport',
        loadChildren: () => import('./../../views/pages/reports/divisionwisereport/divisionwisereport.module').then(m => m.DivisionwisereportModule)
      },
      {
        path: 'subdivisionwisereport',
        loadChildren: () => import('./../../views/pages/reports/subdivisionwisereport/subdivisionwisereport.module').then(m => m.SubdivisionwisereportModule)
      },
      {
        path: 'viilagewisereport',
        loadChildren: () => import('./../../views/pages/reports/villagewisereport/villagewisereport.module').then(m => m.VillagewisereportModule)
      },
      {
        path: 'districtwisereport',
        loadChildren: () => import('./../../views/pages/reports/districtwisereport/districtwisereport.module').then(m => m.DistrictwisereportModule)
      },
      {
        path: 'districtwithsubdivisionwisereport',
        loadChildren: () => import('./../../views/pages/reports/showsubdivisionreport/showsubdivisionreport.module').then(m => m.ShowsubdivisionreportModule)
      },
      {
        path: 'subdivisionwiseflowprogressreport',
        loadChildren: () => import('./../../views/pages/reports/subdivisionwiseflowprogressreport/subdivisionwiseflowprogressreport.module').then(m => m.SubdivisionWiseFlowProgressReportModule)
      },
      {
        path: 'divisionwithsubdivisionwisetargetreport',
        loadChildren: () => import('./../../views/pages/reports/divisionwithsubdivisionwiseprogressreport/divisionwithsubdivisionwiseprogressreport.module').then(m => m.DivisionwithsubdivisionwiseprogressreportModule)
      },
      {
        path: 'beneficiaryreport',
        loadChildren: () => import('./../../views/pages/reports/beneficiaryreport/beneficiaryreport.module').then(m => m.BeneficiaryreportModule)
      },
      {
        path: 'mfdashboard',
        loadChildren: () => import('./../../views/pages/dbt/dashboard/dbtdashboard.module').then(m => m.DbtDashboardModule)
      },
      {
        path: 'dealer',
        loadChildren: () => import('./../../views/pages/dbt/dealer/dealer.module').then(m => m.DealerModule)
      },
      {
        path: 'dealeruserprofile',
        loadChildren: () => import('../pages/dbt/dealeruserpdf/dealeruserpdf.module').then(m => m.DealerUserPdfModule)
      },
      {
        path: 'workorderreceipt',
        loadChildren: () => import('../pages/dbt/workorderreceipt/workorderreceipt.module').then(m => m.WorkOrderReceiptModule)
      },
      {
        path: 'dealermanufacture',
        loadChildren: () => import('../pages/dbt/dealermanufacture/dealermanufacture.module').then(m => m.DealerManufacturModule)
      },
      {
        path: 'dealerproduct',
        loadChildren: () => import('../pages/dbt/dealerproduct/dealerproduct.module').then(m => m.DealerProductModule)
      },
      {
        path: 'product/:id',
        loadChildren: () => import('./../../views/pages/dbt/product/product.module').then(m => m.ProductModule)
      },
      {
        path: 'manufacturer/:id/:actionInfo',
        loadChildren: () => import('./../../views/pages/dbt/manufacturer/manufacturer.module').then(m => m.ManufacturerModule)
      },
      // path to manufacturer-details component
      {
        path: 'manufacturerdetail/:id/:actionInfo',
        component: ManufacturerDetailComponent
      },
      {
        path: 'manufactureview',
        component: DealerManufactureViewComponent
      },


      {
        path: 'userfbdetails/:id/:actionInfo',
        component: UserfbDetailsComponent
      },
      {
        path: 'hodashboard',
        loadChildren: () => import('./../../views/pages/dbt/hodashboard/hodashboard.module').then(m => m.HoDashboardModule)
      },
      {
        path: 'manufacturerlist',
        loadChildren: () => import('./../../views/pages/dbt/homanufacturer/homanufacturer.module').then(m => m.HoManufacturerModule)
      },
      {
        path: 'dealerlist',
        loadChildren: () => import('./../../views/pages/dbt/hodealer/hodealer.module').then(m => m.HodealerdModule)
      },
      // {
      //   path: 'farmerlist',
      //   loadChildren: () => import('./../../views/pages/dbt/hofarmer/hofarmer.module').then(m => m.HoFarmerModule)
      // },
      {
        path: 'farmerlist',
        loadChildren: () => import('../pages/dbt/dbtdashboardnew/dbtdashboardnew.module').then(m => m.DbtdashboardnewModule)
      },

      {
        path: 'geologist',
        loadChildren: () => import('./../../views/pages/master/geologist/geologist.module').then(m => m.GeologistModule)
      },
      {
        path: 'userfeedbackhistory',
        loadChildren: () => import('./../../views/pages/master/userfeedbackhistory/userfb.module').then(m => m.UserfbModule)
      },
      {
        path: 'dealerproductmapping',
        loadChildren: () => import('./../../views/pages/dbt/dealerproductmapping/dealerproductmapping.module').then(m => m.DealerProductMappingModule)
      },
      {
        path: 'dealerdashboard',
        loadChildren: () => import('./../../views/pages/dbt/dealerdashboard/dealerdashboard.module').then(m => m.DealerDashboardModule)
      },
      {
        path: 'dealerinfo',
        loadChildren: () => import('./../../views/pages/dbt/dealerinfo/dealerinfo.module').then(m => m.DealerinfoModule)
      },
      {
        path: 'dealerprofile',
        loadChildren: () => import('./../../views/pages/dbt/dealerprofile/dealerprofile.module').then(m => m.DealerprofileModule)
      },
      {
        path: 'statetarget',
        loadChildren: () => import('../pages/dbt/target/stateleveltargetlist/stateleveltargetlist.module').then(m => m.StateLevelTargetListModule)
      },
      {
        path: 'targetapproval',
        loadChildren: () => import('../pages/dbt/target/targetapprovedlist/targetapprovedlist.module').then(m => m.TargetApprovedListModule)
      },
      {
        path: 'subdivisiontargetlist/:id',
        loadChildren: () => import('./../../views/pages/dbt/target/subdivisiontarget/subdivisionleveltarget/subdivisionleveltarget.module').then(m => m.SubDivisionLevelTargetModule)
      },
      {
        path: 'subdivisiontarget',
        loadChildren: () => import('./../../views/pages/dbt/target/subdivisiontarget/subdivisiontarget.module').then(m => m.SubDivisionTargetModule)
      },
      {
        path: 'villagetarget',
        loadChildren: () => import('./../../views/pages/dbt/target/villagelevel/villagelevel.module').then(m => m.VillagelevelModule)
      },
      {
        path: 'villageleveltarget/:id',
        loadChildren: () => import('./../../views/pages/dbt/target/villagelevel/villageleveltarget/villageleveltarget.module').then(m => m.VillageLevelTargetModule)
      },
      {
        path: 'divisiontarget',
        loadChildren: () => import('./../../views/pages/dbt/target/distlevel/distlevel.module').then(m => m.DistlevelModule)
      },
      {
        path: 'statetargetlist/:id',
        loadChildren: () => import('./../../views/pages/dbt/target/dbtstatetarget.module').then(m => m.DbtstatetargetModule)
      },
      {
        path: 'divisiontargetlist',
        loadChildren: () => import('./../../views/pages/dbt/target/distlevel/divisiontargetlist/divisiontargetlist.module').then(m => m.DivisionTargetListComponentModule)
      },
      {
        path: 'subdivisiontargetlist',
        loadChildren: () => import('./../../views/pages/dbt/target/subdivisiontarget/subdivisiontargetlist/subdivisiontargetlist.module').then(m => m.SubDivisionTargetListModule)
      },
      {
        path: 'divisionleveltarget/:id',
        loadChildren: () => import('./../../views/pages/dbt/target/distlevel/divisionleveltarget/divisionleveltarget.module').then(m => m.DivisionLevelTargetModule)
      },
      {
        path: 'gpsdownload',
        loadChildren: () => import('./../../views/pages/gpsdashboard/gpsdashboard.module').then(m => m.GpsdashboardModule)
      },
      {
        path: 'farmer',
        loadChildren: () => import('../pages/dbt/farmerlist/farmerlist.module').then(m => m.FarmerlistModule)
      },
      {
        path: 'viewfarmer',
        loadChildren: () => import('../pages/dbt/viewfarmerdetails/viewfarmerdetails.module').then(m => m.ViewfarmerdetailsModule)
      },
      {
        path: 'gramapanchayat',
        loadChildren: () => import('../pages/master/gramapanchayat/gramapanchayat.module').then(m => m.GramapanchayatModule)
      },
      // {
      //   path: 'farmerTimeLine/:id',
      //   component: FarmertimelineComponent
      // },
      // {
      //   path: 'farmerTimeLine/:id',
      //   loadChildren: () => import('../pages/dbt/farmertimeline/farmertimeline.module').then(m => m.FarmertimelineModule)
      // },
      {
        path: 'aeefarmerbooking',
        loadChildren: () => import('../pages/aeefarmerbookingapproval/aeefarmerbookingapproval.module').then(m => m.AeefarmerbookingapprovalModule)
      },
      {
        path: 'aeefarmerbookingview',
        loadChildren: () => import('../pages/aeefarmerbookingapproval/aeefarmerbookingapprovalview/aeefarmerbookingapprovalview.module').then(m => m.aeefarmerbookingapprovalviewComponentModule)
      },
      {
        path: 'aefarmerbookingview',
        loadChildren: () => import('../pages/aefarmerbookingapproval/aefarmerbookingapprovalview/aefarmerbookingapprovelview.module').then(m => m.aefarmerbookingapprovalviewModule)
      },

      {
        path: 'eefarmerbookingapproval',
        loadChildren: () => import('../pages/aeefarmerbookingapproval/eefarmerbookingapproval/eefarmerbookingapproval.module').then(m => m.eefarmerbookingapprovalComponentModule)
      },
      {
        path: 'eefarmerbookingapprovalview',
        loadChildren: () => import('../pages/aeefarmerbookingapproval/eefarmerbookingapprovalview/eefarmerbookingapprovalview.module').then(m => m.eefarmerbookingapprovalviewComponentModule)
      },
      {
        path: 'aefarmerbooking',
        loadChildren: () => import('../pages/aefarmerbookingapproval/aeafarmerbookingapprovel.module').then(m => m.aefarmerbookingapprovalModule)
      },
      {
        path: 'pvtmachinery',
        loadChildren: () => import('../pages/pvtmachinery/pvtmachinery.module').then(m => m.PvtMachineryModule)
      },
      {
        path: 'pvtmachinery/view',
        loadChildren: () => import('../pages/pvtmachinery/view-pvtmachinery/view-pvtmachinery.module').then(m => m.ViewPvtmachineryModule)
      },
      {
        path: 'pvtbooking',
        loadChildren: () => import('../pages/pvtbooking/pvtbooking.module').then(m => m.PvtbookingModule)
      },
      {
        path: 'psbooking',
        loadChildren: () => import('../pages/pvtbooking/pvtbooking.module').then(m => m.PvtbookingModule)
      },
      {
        path: 'paccsbookingdetailsreport',
        loadChildren: () => import('../pages/paacs/paccsbookingdetailsreport/paccsbookingdetailsreport.module').then(m => m.PaccsbookingdetailsreportModule)
      },
      {
        path: 'pvtbooking/view/:id',
        loadChildren: () => import('../pages/pvtbooking/viewpvtbooking/viewpvtbooking.module').then(m => m.ViewpvtbookingModule)
      },
      {
        path: 'psbooking/view/:id',
        loadChildren: () => import('../pages/pvtbooking/viewpvtbooking/viewpvtbooking.module').then(m => m.ViewpvtbookingModule)
      },
      {
        path: 'pvtimplement',
        loadChildren: () => import('../pages/pvtimplement/pvtimplement.module').then(m => m.PvtImplementModule)
      },
      {
        path: 'pvtimplement/view',
        loadChildren: () => import('../pages/pvtimplement/view-pvtimplement/view-pvtimplement.module').then(m => m.ViewPvtimplementModule)
      },
      {
        path: 'manufacturerbookinglist',
        loadChildren: () => import('../pages/dbt/manufacturerfarmerbooking/manufacturerfarmerbooking.module').then(m => m.ManufacturerfarmerbookingModule)
      },
      {
        path: 'dbtdashboardnew',
        loadChildren: () => import('../pages/dbt/dbtdashboardnew/dbtdashboardnew.module').then(m => m.DbtdashboardnewModule)
      },
      {
        path: 'ViewmanufacturerbookingDetails',
        loadChildren: () => import('../pages/dbt/viewbookingfarmer/viewbookingfarmer.module').then(m => m.ViewbookingfarmerModule)
      },

      {
        path: 'divisionwisetargetreport',
        loadChildren: () => import('../pages/reports/divisionwisetargetreport/divisionwisetargetreport.module').then(m => m.DivisionwisetargetreportModule)
      },
      {
        path: 'bankname',
        loadChildren: () => import('../pages/master/banknamedetails/banknamedetails.module').then(m => m.BanknamedetailsModule)
      },
      {
        path: 'bankcity',
        loadChildren: () => import('../pages/master/bankcityname/bankcityname.module').then(m => m.BankcitynameModule)
      },
      {
        path: 'bankbranch',
        loadChildren: () => import('../pages/master/bankbranch/branchname.module').then(m => m.BranchnameModule)
      },
      {
        path: 'beneficiarydetailreport',
        loadChildren: () => import('../pages/reports/beneficiarydetails/beneficiarydetails.module').then(m => m.BeneficiarydetailsModule)
      },
      {
        path: 'paccsbooking',
        loadChildren: () => import('../pages/dbt/paacsbooking/paacsbookingroute/paacsbookingroute.module').then(m => m.PaacsbookingrouteModule)
      },
      {
        path: 'paccsdashboard',
        loadChildren: () => import('../pages/dbt/paacsbooking/paccsdashboard/paccsdashboard.module').then(m => m.paccsashboardModule)
      },
      {
        path: 'paccswisereport',
        loadChildren: () => import('../pages/reports/paccswisereport/paccswisereport.module').then(m => m.PaccswisereportModule)
      },
      {
        path: 'paccswisedialyreport',
        loadChildren: () => import('../pages/reports/paccsdialyreport/paccsdialyreport.module').then(m => m.PaccsdialyreportModule)
      },
      {
        path: 'paccsinfo',
        loadChildren: () => import('../pages/dbt/paacsbooking/paccsinfo/paccsinfo.module').then(m => m.PaccsinfoModule)
      },
      {
        path: 'paccsusers',
        loadChildren: () => import('../pages/master/paccsuser/paccsuser.module').then(m => m.PaccsuserModule)
      },
      {
        path: 'unitwiseutilizationreport',
        loadChildren: () => import('../pages/reports/unitwiseutilizationreport/unitwiseutilizationreport.module').then(m => m.UnitwiseutilizationreportModule)
      },
      {
        path: 'subsidyschemestatusreport',
        loadChildren: () => import('../pages/reports/subsidyschemestatusreport/subsidyschemestatusreport.module').then(m => m.SubsidyschemestatusreportModule)
      },
      {
        path: 'pvtblockwisestatusreport',
        loadChildren: () => import('../pages/reports/pvtblockwisestatusreport/pvtblockwisestatusreport.module').then(m => m.PvtblockwisestatusreportModule)
      },
      {
        path: 'paccsblockwisemachinarystatusreport',
        loadChildren: () => import('../pages/reports/pvtblockwisemachinarystatusreport/pvtblockwisemachinarystatusreport.module').then(m => m.PvtblockwisemachinarystatusreportModule)
      },
      {
        path: 'pvtblockwisemachinarystatusreport',
        loadChildren: () => import('../pages/reports/pvtblockwisemachinarystatusreport/pvtblockwisemachinarystatusreport.module').then(m => m.PvtblockwisemachinarystatusreportModule)
      },


      {
        path: 'pvtsubdivisionstatusreport',
        loadChildren: () => import('../pages/reports/pvtsubdivisionwisestatusreport/pvtsubdivisionwisestatusreport.module').then(m => m.PvtsubdivisionwisestatusreportModule)
      },
      {
        path: 'farmercultivationdetailsreport',
        loadChildren: () => import('../pages/reports/farmercultivationdetailsreport/farmercultivationdetailsreport.module').then(m => m.FarmercultivationdetailsreportModule)
      },
      {
        path: 'farmerbookingdetails',
        loadChildren: () => import('../pages/farmerbookingdetails/farmerbookingdetails.module').then(m => m.FarmerbookingdetailsModule)
      },
      {
        path: 'paccswiseprogressreport',
        loadChildren: () => import('../pages/reports/paccswiseprogressreport/paccswiseprogressreport.module').then(m => m.PaccswiseprogressreportModule)
      },
      {
        path: 'districtwisepaccsprogressreport',
        loadChildren: () => import('../pages/reports/districtwisepaccsprogressreport/districtwisepaccsprogressreport.module').then(m => m.DistrictwisepaccsprogressreportModule)
      },
      {
        path: 'makkaludanmudhalvarschemecampreport',
        loadChildren: () => import('../pages/reports/makkaludanmudhalvarschemecampreport/makkaludanmudhalvarschemecampreport.module').then(m => m.MakkaludanmudhalvarschemecampreportModule)
      },
      {
        path: 'logbookreport',
        loadChildren: () => import('../pages/reports/logbookreport/logbookreport.module').then(m => m.LogbookreportModule)
      },
      {
        path: 'pendencyreport',
        loadChildren: () => import('../pages/reports/bookingdetailsand-pendencyreport/bookingdetailsand-pendencyreport.module').then(m => m.BookingdetailsandPendencyreportModule)
      },
      {
        path: 'financialyear',
        loadChildren: () => import('../pages/master/financialyear/financialyear.module').then(m => m.FinancialyearModule)
      },
      {
        path: 'department',
        loadChildren: () => import('../pages/master/depatrment/department.module').then(m => m.DepartmentModule)
      },
      {
        path: 'dbtcomponent',
        loadChildren: () => import('../pages/master/component/component.module').then(m => m.ComponentModule)
      },
      {
        path: 'dbtgo',
        loadChildren: () => import('../pages/master/GO/GO.module').then(m => m.GOModule)
      },
      {
        path: 'dbtscheme',
        loadChildren: () => import('../pages/master/scheme/scheme.module').then(m => m.SchemeModule)
      },
      {
        path: 'serviceprovider',
        loadChildren: () => import('../pages/Private EVaadagai/serviceprovider/serviceprovider.module').then(m => m.ServiceproviderModule)
      },
      {
        path: 'pvtevaadagaidashboard',
        loadChildren: () => import('../pages/Private EVaadagai/pvt-evaadagai-dashboard/pvt-evaadagai-dashboard.module').then(m => m.PvtEvaadagaiDashboardModule)
      },
      {
        path: 'psevaadagaidashboard',
        loadChildren: () => import('../pages/Private EVaadagai/pvt-evaadagai-dashboard/pvt-evaadagai-dashboard.module').then(m => m.PvtEvaadagaiDashboardModule)
      },
      {
        path: 'bookingstatusreport',
        loadChildren: () => import('../pages/Private EVaadagai/districtwisestatusreport/districtwisestatusreport.module').then(m => m.DistrictWiseStatusReport)
      },
      {
        path: 'districtwiseimplementreport',
        loadChildren: () => import('../pages/Private EVaadagai/districtwisemachinarystatusreport/districtwisemachinarystatusreport.module').then(m => m.DistrictWiseMchinaryStatusReport)
      },
      {
        path: 'paccsdistrictwiseimplementreport',
        loadChildren: () => import('../pages/Private EVaadagai/districtwisemachinarystatusreport/districtwisemachinarystatusreport.module').then(m => m.DistrictWiseMchinaryStatusReport)
      },

      {
        path: 'spstatusreport',
        loadChildren: () => import('../pages/reports/serviceproviderstatusreport/serviceproviderstatusreport.module').then(m => m.SchemewisereportModule)
      },
      {
        path: 'paccsstatusdetailsreport',
        loadChildren: () => import('../pages/reports/paccsstatusdetailsreport/paccsstatusdetailsreport.module').then(m => m.PaccsstatusdetailsreportModule)
      },
      {
        path: 'bookingdetailreport',
        loadChildren: () => import('../pages/Private EVaadagai/bookingreport/bookingreport.module').then(m => m.BookingReportModule)
      },
      {
        path: 'pvtpendencyreport',
        loadChildren: () => import('../pages/Private EVaadagai/Pendencyreport/reviewreport.module').then(m => m.ReviewreportModule)
      },
      {
        path: 'paccsimplementreport',
        loadChildren: () => import('../pages/reports/paccsimplementreport/paccsimplementreport.module').then(m => m.PaccsimplementreportModule)
      },
      {
        path: 'payout',
        loadChildren: () => import('../pages/Private EVaadagai/payout/payout.module').then(m => m.PayoutModule)
      },
      {
        path: 'pendencyreport',
        loadChildren: () => import('../pages/reports/bookingdetailsand-pendencyreport/bookingdetailsand-pendencyreport.module').then(m => m.BookingdetailsandPendencyreportModule)
      },
      {
        path: 'PVTServiceProvidersStatusReport',
        loadChildren: () => import('../pages/reports/pvtserviceproviderstatusreport/pvtserviceproviderstatusreport.module').then(m => m.PvtserviceproviderstatusreportModule)
      },
      {
        path: 'paccsregistrationstatusreport',
        loadChildren: () => import('../pages/reports/paccsregistrationstatusreport/paccsregistrationstatusreport.module').then(m => m.PaccsregistrationstatusreportModule)
      },
      {
        path: 'e2eschemeprogressreport',
        loadChildren: () => import('../pages/reports/e2eschemeprogressreport/e2eschemeprogressreport.module').then(m => m.E2eschemeprogressreportModule)
      },
      {
        path: 'e2emechanizationreport',
        loadChildren: () => import('../pages/reports/e2emechanizationreport/e2emechanizationreport.module').then(m => m.E2emechanizationreportModule)
      },
      {
        path: 'finacialyear',
        loadChildren: () => import('../pages/master/financialyear/financialyear.module').then(m => m.FinancialyearModule)
      },
      {
        path: 'dbtproduct',
        loadChildren: () => import('../pages/master/dbtproduct/dbtproduct.module').then(m => m.DbtproductModule)
      },
      {
        path: 'schemedbtgo',
        loadChildren: () => import('../pages/master/dbtgoscheme/dbtgoscheme.module').then(m => m.DbtgoschemeModule)
      },
      {
        path: 'pvtonlinereceipt',
        loadChildren: () => import('../pages/Private EVaadagai/onlinereceipt/onlinereceipt.module').then(m => m.OnlinereceiptModule)
      },
      {
        path: 'machinarycategory',
        loadChildren: () => import('../pages/master/machinary-category/machinary-category.module').then(m => m.MachinaryCategoryModule)
      },
      {
        path: 'machinaryclasification',
        loadChildren: () => import('../pages/master/machinary-clasification/machinary-clasification.module').then(m => m.MachinaryClasificationModule)
      },
      {
        path: 'powersource',
        loadChildren: () => import('../pages/master/power-source/power-source.module').then(m => m.PowerSourceModule)
      },
      {
        path: 'configdbtproduct',
        loadChildren: () => import('../pages/master/dbtproductconfig/dbtproductconfig.module').then(m => m.DbtproductconfigModule)
      },
      {
        path: 'specdbtproduct',
        loadChildren: () => import('../pages/master/dbt-product-spec/dbt-product-spec.module').then(m => m.DbtProductSpecModule)
      },
      {
        path: 'componentdbtproduct',
        loadChildren: () => import('../pages/master/dbtproductcomponentmapping/dbtproductcomponentmapping.module').then(m => m.DbtproductcomponentmappingModule)
      },
      {
        path: 'subsidydbtproduct',
        loadChildren: () => import('../pages/master/dbtproductsubsitymap/dbtproductsubsitymap.module').then(m => m.DbtproductsubsitymapModule)
      },
      {
        path: 'runlottery',
        component: RunLotteryComponent
      },
      {
        path: 'lotterydashboard',
        component: LotteryDashboardComponent
      },
      {
        path: 'lotteryreport',
        component: LotteryReportComponent
      },
      {
        path: 'dbtdistrictwiseflowprogressreport',
        component: DbtDistrictWiseFlowProgressReportComponent
      },
      {
        path: 'dbtvillagewiseflowprogressreport',
        component: DbtVillageWiseFlowProgressReportComponent
      },
      {
        path: 'dbtdivisionwiseflowprogressreport',
        component: DbtDivisionWiseFlowProgressReportComponent
      },
      {
        path: 'manufacturerreport',
        component: ManufacturerReportComponent
      },
      {
        path: 'ticketforwardusermapping',
        loadChildren: () => import('../pages/master/ticketforwardusermapping/ticketforwardusermapping.module').then(m => m.TicketforwardusermappingModule)
      },
      {
        path: 'dbtwaitinglistreport',
        loadChildren: () => import('../pages/reports/waitinglistreport/waitinglistreport.module').then(m => m.WaitinglistreportModule)
      },
      {
        path: 'implementscategory',
        loadChildren: () => import('../pages/master/implementscategory/implementcategory.module').then(m => m.ImplementscategoryModule)
      },
      {
        path: 'summarydivisionwiseutilizationreport',
        loadChildren: () => import('./../../views/pages/reports/divisionwiseutilizationreportsummary/divisionwiseutilizationreport.module').then(m => m.DivisionWiseUtilizationreportsummaryModule)

      },
      {
        path: 'spregistrationsummaryreport',
        loadChildren: () => import('../pages/reports/sp-registration-summary/sp-registration-summary.module').then(m => m.SpRegistrationSummaryModule)
      },
      {
        path: 'paccsbookingstatusreport',
        loadChildren: () => import('../pages/reports/paccsbookingstatusreport/paccsbookingstatusreport.module').then(m => m.PaccsbookingstatusreportModule)
      },
      {
        path: 'e2efarmerdetails',
        loadChildren: () => import('../pages/e2efarmmechanization/e2efarmerdetails/e2efarmerdetails.module').then(m => m.e2efarmerdetailsModule)
      },
      {
        path: 'e2eEntrepreneurdetails',
        loadChildren: () => import('../pages/e2efarmmechanization/e2eentrepreneur/e2eentrepreneur.module').then(m => m.E2eentrepreneurModule)
      },
      {
        path: 'e2edashboard',
        loadChildren: () => import('../pages/e2efarmmechanization/analyticsdashboard/analyticsdashboard.module').then(m => m.AnalyticsdashboardModule)
      },
      {
        path: 'blockLevelTarget',
        loadChildren: () => import('../pages/e2efarmmechanization/blockleveltarget/blockleveltarget.module').then(m => m.BlockleveltargetModule)
      },
      {
        path: 'e2eCropMaster',
        loadChildren: () => import('../pages/e2efarmmechanization/e2ecropmaster/e2ecropmaster.module').then(m => m.E2ecropmasterModule)
      },
      {
        path: 'divisionLevelTarget',
        loadChildren: () => import('../pages/e2efarmmechanization/statetodistricttarget/statetodistricttarget.module').then(m => m.StatetodistricttargetModule)
      },
      {
        path: 'farmerwaitinglist',
        loadChildren: () => import('../pages/aefarmerbookingapproval/farmerwaitinglist/farmerwaitinglist.module').then(m => m.FarmerwaitinglistModule)
      },
      {
        path: 'farmerwaitinglistview',
        loadChildren: () => import('../pages/aefarmerbookingapproval/aefarmerbookingapprovalview/aefarmerbookingapprovelview.module').then(m => m.aefarmerbookingapprovalviewModule)
      },
      {
        path: 'paccsserviceprovider',
        loadChildren: () => import('../pages/paacs/paacsbankdetails/paacsbankdetails.module').then(m => m.PaacsbankdetailsModule)
      },
      {
        path: 'paccspayout',
        loadChildren: () => import('../pages/paacs/Paccs-Payout/paccsPayout.module').then(m => m.PaccsPayoutModule)
      },
      {
        path: 'paccsonlinereceipt',
        loadChildren: () => import('../pages/paacs/Paccs-Payout/Paccs-onlinereceipt/paccsOnlinereceipts.module').then(m => m.OnlinereceiptModule)
      },
      //       {
      // path: 'timeline/:id',
      // loadChildren: () =>
      //     import('./../../views/pages/ticketing-system/timeline-view/timeline-view.module').then(
      //       m => m.TimelineViewModule
      //     )
      // },

      {
        path: "ticketingsystem/pendingstatus/:financialYearId",
        loadChildren: () =>
          import("../pages/ticketing-system/pending-status-dashboard/pending-status-dashboard.module")
            .then((m) => m.PendingStatusDashboardModule),
      },
      {
        path: "ticketingsystem/:id/:actionInfo",
        loadChildren: () =>
          import("../pages/ticketing-system/create-ticket/create-ticket/create-ticket.module")
            .then((m) => m.CreateTicketModule),
      },
      {
        path: "ticketingsystem/:id",
        loadChildren: () =>
          import("../pages/ticketing-system/timeline-view/timeline-view.module")
            .then((m) => m.TimelineViewModule),
      },
      {
        path: 'ticketingsystem',
        loadChildren: () => import('../pages/ticketing-system/ticketing-system.module')
          .then(m => m.TicketingSystemModule)
      },
      {
        path: 'paccsevaadagairegionwisereport',
        loadChildren: () => import('../pages/reports/paccsEvaadagaiReport/paccsevaadagaireport.module').then(m => m.PaccsevaadagaireportModule)
      },
      {
        path: 'paccsdetailregionwisereport',
        loadChildren: () => import('../pages/reports/paccsDetailsReport/paccsdetailreport.module').then(m => m.PaccseDetailreportModule)
      },
      {
        path: 'paccsduplicate',
        loadChildren: () => import('../pages/paccsduplicate/paccsduplicate.module').then(m => m.PaccsduplicateModule)
      },
      {
        path: 'departmentpayout',
        loadChildren: () => import('../pages/sp_department_accounts/departmentpayout.module').then(m => m.DepartmentPayoutModule)
      },

      {
        path: 'departmentpayout/:id',
        loadChildren: () => import('../pages/sp_department_accounts/departmentpayout.module').then(m => m.DepartmentPayoutModule)
      },




      {
        path: 'serviceprovider/view',
        component: ToggleMachImpleComponent
      },
      {
        path: 'paccsserviceprovider/view',
        component: ToggleMachImpleComponent
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LayoutRoutingModule { }
